import { render } from "./InterfaceTab.vue?vue&type=template&id=e777e1fa&scoped=true"
import script from "./InterfaceTab.vue?vue&type=script&lang=js"
export * from "./InterfaceTab.vue?vue&type=script&lang=js"

import "./InterfaceTab.vue?vue&type=style&index=0&id=e777e1fa&scoped=true&lang=scss"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e777e1fa"]])

export default __exports__